export default "__VITE_ASSET__CNvJG2MM__"